import { useEffect } from 'react';

export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `NAIT.EE | ${title}` : 'NAIT.EE';
    return () => { document.title = 'NAIT.EE'; };
  }, [title]);
}
